import { If } from "components";
import { QRCodeSVG } from "qrcode.react";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { ClipLoader } from "react-spinners";
import { Button, Modal } from "ui";

import { useCreateInventoryBoxQr } from "../../../apis";
import { InventoryBoxQrModalProps } from "./InventoryBoxQrModal.types";

import styles from "./InventoryBoxQrModal.module.scss";

const InventoryBoxQrModal = ({
  isOpen,
  onClose,
  refetchInventoryBoxesQrsList
}: InventoryBoxQrModalProps) => {
  const { t } = useTranslation();

  const {
    mutate: mutateCreateInventoryBoxQr,
    data: newCreatedBoxQrItem,
    isLoading: isNewQrCreating,
    reset: resetCreateInventoryBoxQr
  } = useCreateInventoryBoxQr({
    onSuccess: () => {
      toast.success(t("New inventory box QR created successfully"));
      refetchInventoryBoxesQrsList();
    }
  });

  const createNewQr = async () => {
    mutateCreateInventoryBoxQr({});
  };

  const closeModal = () => {
    resetCreateInventoryBoxQr();
    onClose();
  };

  const modalFooter = newCreatedBoxQrItem ? (
    <Button
      title={`${t("Done")}`}
      onClick={closeModal}
      className={styles.qrModal_footerBtn}
    />
  ) : (
    <Button
      title={`${t("Create")}`}
      className={styles.qrModal_footerBtn}
      onClick={createNewQr}
      loading={isNewQrCreating}
    />
  );

  return (
    <Modal
      title={`${t("New QR")}`}
      className={styles.qrModal}
      isOpen={isOpen}
      onClose={closeModal}
      footer={modalFooter}
    >
      <div className={styles.qrModal_qrContainer}>
        <If condition={newCreatedBoxQrItem}>
          <QRCodeSVG
            value={newCreatedBoxQrItem?.id as string}
            width={"100%"}
            height={"100%"}
            className={styles.qrModal_qr}
          />
        </If>

        <If condition={isNewQrCreating}>
          <ClipLoader size={30} color="#fb3973" />
        </If>

        <If condition={!newCreatedBoxQrItem && !isNewQrCreating}>
          <p>{`${t("Click the “Create” button to generate a new QR")}`}</p>
        </If>
      </div>
    </Modal>
  );
};

export default InventoryBoxQrModal;
